import React from "react";
import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import ConnectWalletBtn from "../components/ConnectWalletBtn";
import { CONSTANTS } from "../shared/constants";
import { images } from "../shared/images";
import nfmClaimAbi from "../shared/blockchain/nfmClaimAbi.json";
import { ethers } from "ethers";

const Rewards = () => {
	// const [openTable, setOpenTable] = useState(false);
	const [isWalletConnected, setIsWalletConnected] = useState(false);
	const [walletAddress, setWalletAddress] = useState("");
	const [network, setNetwork] = useState(0);
	const [allowedRewards, setAllowedRewards] = useState(0);
	const [nextClaimAvailable, setNextClaimAvailable] = useState(0);
	const [isAllowedToClaim, setIsAllowedToClaim] = useState(false);
	const [claimedRewards, setClaimedRewards] = useState(0);

	useEffect(() => {
		let wallet_connection = localStorage.getItem("wallet_connection");
		let wallet_address = localStorage.getItem("wallet_address");
		let chain_id = localStorage.getItem("chain_id");
		setIsWalletConnected(wallet_connection);
		setWalletAddress(wallet_address);
		setNetwork(chain_id);

		if (parseInt(chain_id) === parseInt(CONSTANTS.CLAIM_NETWORK_ID)) {
			fetchRewards(wallet_address);
			claimInfo(wallet_address);
		}

		// if (chain_id !== CONSTANTS.CLAIM_NETWORK_ID) {
		//   toast.dismiss();
		//   toast.error(`Please switch network to ${CONSTANTS.CLAIM_NETWORK_NAME}`);
		//   setWalletAddress("");
		//   setIsWalletConnected(false);
		//   setNetwork(0);
		//   localStorage.removeItem("wallet_connection", false);
		//   localStorage.removeItem("wallet_address", "");
		//   localStorage.removeItem("chain_id", 0);
		//   return;
		// } else {
		//   fetchRewards(wallet_address);
		//   claimInfo(wallet_address);
		// }
	}, []);

	const fetchRewards = (walletAddress) => {
		console.log("Fetch Rewards");
		try {
			var data = JSON.stringify({
				wallet_address: walletAddress,
			});
			var config = {
				method: "post",
				url: `${CONSTANTS.REACT_CLAIM_REWARDS_API}/getNftRewardsList`,
				headers: {
					"Content-Type": "application/json",
				},
				data: data,
			};
			axios(config)
				.then(function (response) {
					console.log("response,", response);
					if (response.data.status !== false) {
						if (response.data.data) {
							setAllowedRewards(
								parseFloat(response.data.totalClaimableAmount).toFixed(4)
							);
						} else {
							setAllowedRewards(0);
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		} catch (error) {
			console.log(error);
		}
	};

	const claimInfo = async (walletAddress) => {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		const signer = provider.getSigner();
		// const address = await signer.getAddress();
		const NFM_REWARDS_CLAIM_CONTRACT = new ethers.Contract(
			CONSTANTS.NFM_CLAIM_CONTRACT,
			nfmClaimAbi,
			signer
		);

		let nextAllowedClaim = await NFM_REWARDS_CLAIM_CONTRACT.nextAllowedClaim(
			walletAddress
		);
		let userTotalClaimedRewards = await NFM_REWARDS_CLAIM_CONTRACT.userRewards(
			walletAddress
		);
		setClaimedRewards(ethers.utils.formatEther(userTotalClaimedRewards));
		nextAllowedClaim = parseInt(nextAllowedClaim);
		const utcTimeStamptoString = new Date(
			nextAllowedClaim * 1000
		).toUTCString();
		setNextClaimAvailable(utcTimeStamptoString);
		const utcTimestamp = new Date().getTime() / 1000;
		if (parseInt(utcTimestamp) > nextAllowedClaim) {
			setIsAllowedToClaim(true);
		} else {
			setIsAllowedToClaim(false);
		}
	};

	const claimRewards = async () => {
		console.log("Claim Rewards");

		if (allowedRewards === 0) {
			toast.dismiss();
			toast.error(`You don't have enough rewards to claim`);
			return;
		}

		if (isAllowedToClaim === false) {
			toast.dismiss();
			toast.error(`Your next allowed claim is at ${nextClaimAvailable}`);
			return;
		}

		if (isWalletConnected === true || isWalletConnected === "true") {
			const provider = new ethers.providers.Web3Provider(window.ethereum);
			const signer = provider.getSigner();
			const address = await signer.getAddress();
			const NFM_REWARDS_CLAIM_CONTRACT = new ethers.Contract(
				CONSTANTS.NFM_CLAIM_CONTRACT,
				nfmClaimAbi,
				signer
			);

			var data = JSON.stringify({
				wallet_address: address,
				amount: allowedRewards,
			});

			var config = {
				method: "post",
				url: `${CONSTANTS.REACT_CLAIM_REWARDS_API}/generateNftRewardsClaimSignature`,
				headers: {
					"Content-Type": "application/json",
				},
				data: data,
			};
			console.log(config, "config");

			axios(config).then(async (response) => {
				console.log("response", response);
				if (response.status === 200) {
					let result = response.data;
					let v = 0;

					if (result.signedData.v === "0x1c") {
						v = 28;
					} else if (result.signedData.v === "0x1b") {
						v = 27;
					}
					await NFM_REWARDS_CLAIM_CONTRACT.claimRewards(
						result.amount,
						result.nonce,
						v,
						result.signedData.r,
						result.signedData.s
					)
						.then((transaction) => {
							let explorer = `${CONSTANTS.REWARDS_EXPLORER_URL}/tx/${transaction.hash}`;
							createToast(explorer);
							toast.success("Transaction Initiated");
							return provider.waitForTransaction(transaction.hash);
						})
						.then(function (transactionReceipt) {
							console.log(transactionReceipt);
							if (transactionReceipt.byzantium) {
								toast.dismiss();
								toast.success("Rewards claimed successfully");
							} else {
								toast.dismiss();
								toast.error("Transaction Failed");
							}
						});
				}
			});
		}
	};

	function createToast(url) {
		toast.loading((t) => (
			<span>
				Transaction pending... <br></br>
				<button onClick={() => window.open(url, "_blank")}>
					<b>View Transaction</b>
				</button>
			</span>
		));
	}

	return (
		<div className="rewards">
			<Toaster position="top-right" />
			<div className="rewards__banner">
				<img src={images.rewardBanner} alt="Reward Banner" />
			</div>

			{/* Connect Wallet Button */}
			<ConnectWalletBtn source="rewards" />

			{isWalletConnected && (
				<>
					<div className="mx-width rewards__bot-rewards">
						<h1 className="heading-primary-3 mt-4 text-center">BOT REWARDS</h1>

						<div className="rewards__boxes">
							<div className="rewards__box">
								<p>Claimable Rewards</p>
								<p className="big-font">{allowedRewards} Ncash</p>

								<button className="btn btn-pink" onClick={claimRewards}>
									Claim
								</button>
							</div>
							<div className="rewards__box">
								<p>Claimed Rewards</p>
								<p className="big-font">{claimedRewards} Ncash</p>
							</div>
						</div>

						<p className="text-white text-center mb-small">
							Rewards are calculated and shown till the previous night midnight.
							Staking done today, will start seeing rewards from midnight
							tonight. Please use Etherium network on metamask to claim &
							Rewards can be claimed after 30 days from last claim.
						</p>

						{/* Reward Table */}
						{/* <div className="rewards__table">
							<div
								className="table__head"
								onClick={() => setOpenTable(!openTable)}
							>
								<h4>NFM Reward Transactions</h4>
								<p>
									<i className="fa fa-caret-down"></i>
								</p>
							</div>
							{openTable && (
								<table id="reward-table" className="">
									<thead>
										<tr>
											<th scope="col" className="first-head">
												Tier
											</th>
											<th scope="col" className="right">
												Total Claimed Amount
											</th>
											<th scope="col" className="right">
												Staked Time
											</th>

											<th scope="col" className="right">
												<p className="mb-0 lh-1">
													Claimable Amount <br /> <small>(NCash)</small>
												</p>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="right" data-label="Tier">
												Premium
											</td>
											<td
												className="right staked-by-tbl"
												data-label="Total Claimed Amount"
											>
												<span> 0 NCash</span>
											</td>
											<td className=" right " data-label="Staked Time">
												23-12-2023
											</td>
											<td className="right" data-label="Claimable Amount">
												500 NCash
											</td>
										</tr>
									</tbody>
								</table>
							)}
						</div> */}
					</div>
				</>
			)}
		</div>
	);
};

export default Rewards;
